import styles from "../../../../MapMonitoring/components/AddMarkerModal/AddIncidentModal.module.css";
import React, { useEffect, useMemo, useReducer } from "react";
import { TextField } from "@mui/material";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

import { typeWastesService } from "../../../../../services/guide/typeWastes-service";
import { useFetchGetTypeWasteById } from "../../../../../hooks/guide/useFetchGetTypeWasteById";
import { CreateTypeWastes, UpdateTypeWastes } from "../../../../../types/api/guide/typeWastes.types";

type FormState = { name: string };

type Action =
    | { type: "SET_FIELD"; name: keyof FormState; value: any }
    | { type: "SET_All"; payload: FormState }
    | { type: "RESET" };

const initialState: FormState = { name: "" };

const reducer = (state: FormState, action: Action): FormState => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.name]: action.value };
        case "SET_All":
            return { ...action.payload };
        case "RESET":
            return initialState;
        default:
            return state;
    }
};

interface WasteTypesAddModalProps {
    onClose: () => void;
    refetchData: () => void;
    id?: string;
}

export const WasteTypesAddModal = ({ onClose, refetchData, id }: WasteTypesAddModalProps) => {
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();

    const isEdit = Boolean(id);
    const { data: wasteType, isLoading } = useFetchGetTypeWasteById(id);
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        dispatch({ type: "RESET" });
    }, [id]);

    useEffect(() => {
        if (!isEdit) return;
        if (!id) return;
        if (!wasteType) return;

        const name =
            (wasteType as any)?.name ??
            (wasteType as any)?.data?.name ??
            (wasteType as any)?.item?.name ??
            "";

        dispatch({ type: "SET_All", payload: { name: name ?? "" } });
    }, [isEdit, id, wasteType]);

    useEffect(() => {
        console.log(wasteType)
    }, [wasteType])

    const handleValue = (event: any) => {
        const { name, value } = event.target;
        dispatch({ type: "SET_FIELD", name, value });
    };

    const canSave = useMemo(() => !!state.name.trim(), [state.name]);

    const handleSave = async () => {
        try {
            if (isEdit) {
                if (!id) {
                    showError("Не удалось определить id типа отходов");
                    return;
                }

                const payload: UpdateTypeWastes = { id, name: state.name.trim() };
                await typeWastesService.update(id, payload);

                showSuccess("Тип отходов обновлён");
            } else {
                const payload: CreateTypeWastes = { name: state.name.trim() };
                await typeWastesService.create(payload);

                showSuccess("Тип отходов создан");
            }

            refetchData();
            onClose();
        } catch (e: any) {
            showError(e?.response?.data ?? "Ошибка при обновлении/добавлении типа отходов");
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        {isEdit ? "Редактировать тип отходов" : "Добавить тип отходов"}
                    </h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <div className={styles.modalCoords}>
                            <TextField
                                name="name"
                                value={state.name}
                                onChange={handleValue}
                                fullWidth
                                disabled={isEdit && isLoading}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>
                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!canSave || (isEdit && isLoading)}
                        style={{ opacity: canSave && !(isEdit && isLoading) ? 1 : 0.6 }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>

            <SnackbarComponent />
        </div>
    );
};
